import axios from 'axios';

const AUTO_BATCH_URL = '/autobatching';
const AUTO_BATCH_PREFLIGHT_URL = '/autobatching/preflight';

export const generateAutoBatches = (payload) => {
  return axios.post(AUTO_BATCH_URL, payload);
};

export const getAutoBatchesPreflightData = (payload) => {
  return axios.post(AUTO_BATCH_PREFLIGHT_URL, payload);
};
